import * as api from '../api'
import * as types from '../constants/action-types'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import CategoryService from "../services/CategoryService";
import CartService from "../services/CartService";
import WatchListService from "../services/WatchListService";

/********** Product Action ********/
// recieve products
export const receiveProducts = products => ( {
    type: types.RECEIVE_PRODUCTS,
    products
} );

// recieve categories
export const receiveCategories = categories => ( {
    type: types.RECEIVE_CATEGORIES,
    categories
} );

// refresh local storage

export const refreshUnSafe = ( current ) => ( {
    type: types.REFRESH_STORE,
    current
} )

export const refreshStore = ( current ) => dispatch => {
    dispatch( refreshUnSafe( current ) );
}

// get all products
export const getAllProducts = () => dispatch => {
    api.getProducts().then( products => {
        dispatch( receiveProducts( products ) );
        return products;
    } )
}

// get all categories
export const getAllCategories = () => dispatch => {
    CategoryService.getPagedCategories({page:0, sortField: 'sortOrder', sortOrder: 'asc', size: 20}).then( categories => {
        dispatch( receiveCategories( categories.data.content ) );
        return categories;
    } )
}

/*********** Modal related Action **********/
// display quickview 
export const showQuickViewModal = productId => ( {
    type: types.SHOW_QUICKVIEW,
    productId
} )

// close quickview modal
export const closeQuickViewModal = () => ( {
    type: types.CLOSE_QUICKVIEW
} )

// Show Video & Login modal
export const showModal = ( modal ) => ( {
    type: types.SHOW_MODAL,
    modal: modal
} );

// close Video & Login modal
export const closeModal = ( modal ) => ( {
    type: types.CLOSE_MODAL,
    modal: modal
} );

// don't show Newsletter modal
export const removeNewsletterMdoal = ( modal ) => ( {
    type: types.REMOVE_NEWSLETTER
} )

/************ Cart Action **************/
// add item to cart
export const getCartItems = () => ( dispatch ) => {
    CartService.getCart().then(res => {
        dispatch( handleCartItems( res.data ) );
    }).catch(err => {
        dispatch( handleCartItems( {cartItems: []} ) );
    })
}

export const addToCart = ( product, qty, cartItemOptionTypeDTOS ) => ( dispatch ) => {
    console.log(product)
    CartService.postCartItem({product: {id: product.id}, quantity: qty, cartItemOptionTypeDTOS: cartItemOptionTypeDTOS}).then(res => {
        toast.success( "Item Added to Cart" );
        dispatch( getCartItems(  ) );
        // dispatch( addToCartUnsafe( res.data ) );
    }).catch(err => {
        toast.warn( "Something went wrong!" );
    })
}

export const updateCart = ( cartItem, qty ) => ( dispatch ) => {
    console.log(cartItem, qty)
    CartService.updateCartItem({id: cartItem.id, product: {id: cartItem.product.id}, quantity: qty}).then(res => {
        toast.success( "Cart Item Updated!" );
        dispatch( getCartItems(  ) );
        // dispatch( addToCartUnsafe( res.data ) );
    }).catch(err => {
        toast.warn( "Something went wrong!" );
    })
}

// add item to cart : typical action
export const handleCartItems = ( data ) => ( {
    type: types.GET_CART_ITEMS,
    data
} );
export const addToCartUnsafe = ( data ) => ( {
    type: types.ADD_TO_CART,
    data
} );

export const resetCartItems = () => ({
    type: types.RESET_CART,
    data: null
})

// remove item from wishlist
export const removeFromWishlist = productId => ( dispatch ) => {
    toast.error( "Item removed from Wishlist" );
    dispatch( {
        type: types.REMOVE_FROM_WISHLIST,
        productId
    } )
};

// add item to cart from wishlist
export const addToCartFromWishlist = ( product, qty ) => ( dispatch ) => {
    toast.success( "Item added to Cart" );

    dispatch( {
        type: types.REMOVE_FROM_WISHLIST,
        productId: product.id
    } )

    dispatch( addToCartUnsafe( product, qty ) )
}

// remove item from cart
export const removeFromCart = productId => ( dispatch ) => {
    CartService.deleteCartItem(productId).then(res => {
        toast.success( "Item Removed to Cart" );
        dispatch( getCartItems(  ) );
    }).catch(err => {
        toast.warn( "Something went wrong!" );
    })
};

// change item's qty
export const changeQty = ( productId, qty ) => ( {
    type: types.CHANGE_QTY,
    productId,
    qty
} );

// change shipping method
export const changeShipping = ( shipping ) => ( {
    type: types.CHANGE_SHIPPING,
    shipping
} )

/*********** Wishlist Action *********/
export const getWatchLists = () => ( dispatch ) => {
    WatchListService.getWatchList().then(res => {
        dispatch( handleWatchListItems( res.data ) );
    }).catch(err => {
        dispatch( handleWatchListItems( [] ) );
    })
}

export const handleWatchListItems = ( data ) => ( {
    type: types.GET_WATCHLIST_ITEMS,
    data
} );

export const addToWatchList = ( productId, setWishList ) => ( dispatch ) => {
    WatchListService.postWatchList(productId).then(res => {
        if(setWishList) setWishList(true)
        toast.success( "Item Added to WatchList!" );
        dispatch( getWatchLists() );
        // dispatch( addToCartUnsafe( res.data ) );
    }).catch(err => {
        toast.warn( "Something went wrong!" );
    })
}

export const removeFromWatchList = ( watchListId ) => ( dispatch ) => {
    WatchListService.deleteWatchListItem(watchListId).then(res => {
        toast.success( "Item Removed from Wish List!" );
        dispatch( getWatchLists() );
        // dispatch( addToCartUnsafe( res.data ) );
    }).catch(err => {
        toast.warn( "Something went wrong!" );
    })
}

export const removeFromWatchListBySearching = ( productId, watchLists, setWishList ) => ( dispatch ) => {
    watchLists.map(wl => {
        if(wl.product.id === productId){
            WatchListService.deleteWatchListItem(wl.id).then(res => {
                if(setWishList) setWishList(false)
                toast.success( "Item Removed from Wish List!" );
                dispatch( getWatchLists() );
                // dispatch( addToCartUnsafe( res.data ) );
            }).catch(err => {
                toast.warn( "Something went wrong!" );
            })
        }
    })

}

export const resetWatchListItems = () => ({
    type: types.RESET_WISHLIST,
    data: null
})

// add item to wishlist
export const toggleWishlist = ( product ) => ( dispatch ) => {
    dispatch( toggleWishlistUnsafe( product ) )
}

// add item to wishlist : typical action
export const toggleWishlistUnsafe = ( product ) => ( {
    type: types.TOGGLE_WISHLIST,
    product
} );

/************* Compare Action ***********/
// add to comparelist
export const addToCompare = ( product ) => ( dispatch ) => {
    toast.success( "Item added to Compare" );
    dispatch( addToCompareUnsafe( product ) )
}

export const addToCompareUnsafe = ( product ) => ( {
    type: types.ADD_TO_COMPARE,
    product
} );

// remove all items from cartlist
export const removeFromCompare = productId => ( dispatch ) => {
    toast.success( "Compare item removed" );
    dispatch( removeFromCompareUnsafe( productId ) )
};

export const removeFromCompareUnsafe = ( productId ) => ( {
    type: types.REMOVE_FROM_COMPARE,
    productId
} );

// reset cartlist with intialstate
export const resetCompare = () => ( {
    type: types.RESET_COMPARE
} );


/************** Filter Action ***********/

// set order to sort
export const filterSort = ( sortBy ) => ( dispatch ) => {
    dispatch( {
        type: types.SORT_BY,
        sortBy
    } )
}

// set price range to get suitable products
export const filterPrice = ( range ) => ( dispatch ) => {
    dispatch( {
        type: types.PRICE_FILTER,
        range
    } )
}

// add/remove category to get suitable products
export const toggleCategoryFilter = ( category ) => ( dispatch ) => {
    dispatch( {
        type: types.CATEGORY_FILTER,
        category
    } )
}

// add/remove product size to get suitable products
export const toggleSizeFilter = ( size ) => ( dispatch ) => {
    dispatch( {
        type: types.SIZE_FILTER,
        size
    } )
}

// add/remove color to get suitable products
export const toggleColorFilter = ( color ) => ( dispatch ) => {
    dispatch( {
        type: types.COLOR_FILTER,
        color
    } )
}

// add/remove brand to get suitable products
export const toggleBrandFilter = ( brand ) => ( dispatch ) => {
    dispatch( {
        type: types.BRAND_FILTER,
        brand
    } )
}

// add/remove rating to get suitable products
export const toggleRatingFilter = ( rating ) => ( dispatch ) => {
    dispatch( {
        type: types.RATING_FILTER,
        rating
    } )
}

// reset filter with intialstate
export const resetFilter = () => ( dispatch ) => {
    dispatch( {
        type: types.RESET_FILTER
    } )
}

/************** Newsletter Modal ************/

// hide newsletter modal in homepage
export const hideNewsletterModal = () => ( {
    type: types.HIDE_NEWSLETTER_MODAL
} )